import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  list: { width: '100%' },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: rh(12),
  },
  bankInfo: { alignItems: 'center', flexDirection: 'row', gap: rw(12) },
  bankIcon: { borderRadius: rw(20), height: rw(40), width: rw(40) },
  bankName: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(16), lineHeight: rh(22) },
  screen: { backgroundColor: theme.COLOR_BG_BASE, flex: 1 },
  content: { flex: 1, gap: rh(20), paddingHorizontal: rw(24), paddingTop: rh(24) },
  titleBlock: { gap: rh(12) },
  title: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(28),
    letterSpacing: rw(-0.56),
    lineHeight: rh(33.6),
  },
  subtitle: { color: theme.COLOR_TEXT_SECONDARY, fontSize: rf(16), lineHeight: rh(22) },
  phone: { color: theme.COLOR_TEXT_PRIMARY },
  screenList: { flex: 1 },
  listContent: { paddingBottom: rh(24) },
}))
